import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";
import RouterSessionManagement from "../../controllers/router-session-management";

// a793ab5b-0c62-11e8-a677-d8cb8a9864e4

/**
 * Login route
 *
 * @extends KernelRoute
 */
class FormRoute extends KernelRoute {

    onFail () {
        return window.location = "#not-found";
    }

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/converted(/)")
    convertedRoute (params) {
        this.parsedParams = this.parseQueryString(params);
        let manager = new RouterSessionManagement();

        try {
            manager.obtainOrganisationConfig(this.parsedParams.organisationId).then(config => {
                System.import("./converted").then(View => {
                    const view = new View.default({ params: this.parsedParams, config });
                    raf(_ => App.contentRegion.show(view));
                });
            });
        } catch (error) {
            if (GLOBALS && GLOBALS.DEBUG) console.error(error);
            this.onFail();
        }
        
    }
}

export default FormRoute;



// WEBPACK FOOTER //
// ./public/domain/views/converted/converted.route.js